module.exports = __webpack_public_path__ + "static/media/planta1.82ea7cb3.png";